module.exports = __webpack_public_path__ + "media/assets/logo_login-9139ce891bf28fe441c403a6b717049c.png";